import React, { useState, useEffect } from "react";
import axios from "axios";
import { login } from "../../auth/auth";
import { useNavigate } from "react-router-dom";
import closeMenuIcon from "../../assets/images/bg-close-button.png";
import ExportChat from "./exportChat";
import toast, { Toaster } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Menu = ({ handleShowMenu, messages, userName }) => {
  const [selectedMenu, setSelectedMenu] = useState("MENU");
  const [authToken, setAuthToken] = useState("");
  const [topics, setTopics] = useState([]);
  const [avatars, setAvatars] = useState([]);
  const [selectedPassphrase, setSelectedPassphrase] = useState(
    sessionStorage.getItem("passphrase") || ""
  );
  const [language, setLanguage] = useState(
    sessionStorage.getItem("language") || "English"
  );
  const [configId, setConfigId] = useState(
    parseInt(sessionStorage.getItem("config_id"), 10) || 1
  );
  const [currentAvatar, setCurrentAvatar] = useState(
    sessionStorage.getItem("avatar") || null
  );
  const [activeTopic, setActiveTopic] = useState(
    sessionStorage.getItem("topic") || ""
  );

  const navigate = useNavigate();

  const translations = {
    English: {
      exportTranscript: "Export Transcript",
      changeAvatar: "Change Avatar",
      switchTopic: "Switch Topic",
      switchLanguage: "Switch to Bahasa",
      playGame: "Play a Game",
      confirm: "Do you want to change?",
    },
    Indonesia: {
      exportTranscript: "Ekspor Transkrip",
      changeAvatar: "Ubah Avatar",
      switchTopic: "Ubah Topik",
      switchLanguage: "Beralih ke Bahasa Inggris",
      playGame: "Mainkan Permainan",
      confirm: "Apakah Anda ingin mengubah?",
    },
  };

  useEffect(() => {
    sessionStorage.setItem("config_id", configId);
  }, [configId]);

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  const fetchAvatars = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/config/passphrase/${selectedPassphrase}/language/${language}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const avatarsData = response.data.data;
      setAvatars(avatarsData);

      // Update config_id based on the selected avatar
      if (currentAvatar) {
        const updatedAvatar = avatarsData.find(
          (avatar) => avatar.name === currentAvatar
        );
        if (updatedAvatar) {
          setConfigId(updatedAvatar.id);
        }
      }

      console.log("Avatars:", avatarsData);
    } catch (error) {
      console.error("Failed to fetch avatars:", error);
    }
  };

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/key`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        setTopics(response.data.data);
        console.log("Topics:", response.data.data);
      } catch (error) {
        console.error("Failed to fetch topics:", error);
      }
    };

    if (authToken) {
      fetchTopics();
    } else {
      console.log("No authToken available");
    }
  }, [authToken]);

  useEffect(() => {
    if (selectedPassphrase) {
      fetchAvatars();
    }
  }, [selectedPassphrase, authToken, language]);

  const handleTopicSelect = (passphrase, name) => {
    const language = sessionStorage.getItem("language") || "English";
    const confirmationMessage =
      translations[language].confirm || "Are you sure you want to switch?";

    toast(
      (t) => (
        <div>
          <p>{confirmationMessage}</p>
          <div
            style={{
              background: "white",
              color: "#111",
              padding: "20px 0 0 0",
              borderRadius: "12px",
              width: "320px",
              fontSize: "14px",
              gap: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
                setSelectedPassphrase(passphrase);
                setActiveTopic(name);

                if (name === "FXMedia" || name === "Bank") {
                  sessionStorage.setItem("topic", name);
                  sessionStorage.setItem("passphrase", passphrase);
                  handleShowMenu();
                }
              }}
              style={{
                padding: "6px 18px",
                backgroundColor: "#0063e5",
                color: "white",
                border: "1px solid #0063e5",
                borderRadius: "999px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {language === "Indonesia" ? "Ya" : "Yes"}
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                padding: "6px 18px",
                backgroundColor: "#f0f0f0",
                color: "#111",
                border: "1px solid #ccc",
                borderRadius: "999px",
                cursor: "pointer",
              }}
            >
              {language === "Indonesia" ? "Tidak" : "No"}
            </button>
          </div>
        </div>
      ),
      {
        duration: 999999,
        id: "topic-switch-confirm",
        position: "top-center",
      }
    );
  };

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
  };

  const toggleLanguage = () => {
    const currentLanguage = sessionStorage.getItem("language") || "English";
    const newLanguage = currentLanguage === "English" ? "Indonesia" : "English";
    const confirmationMessage =
      translations[currentLanguage]?.confirm ||
      "Are you sure you want to change language?";

    toast(
      (t) => (
        <div>
          <p>{confirmationMessage}</p>
          <div
            style={{
              background: "white",
              color: "#111",
              padding: "20px 0 0 0",
              borderRadius: "12px",
              width: "320px",
              fontSize: "14px",
              gap: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
                setLanguage(newLanguage);
                sessionStorage.setItem("language", newLanguage);

                if (selectedPassphrase) {
                  fetchAvatars(); // update config_id
                }

                console.log("avatar id", configId);
              }}
              style={{
                padding: "6px 18px",
                backgroundColor: "#0063e5",
                color: "white",
                border: "1px solid #0063e5",
                borderRadius: "999px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {currentLanguage === "Indonesia" ? "Ya" : "Yes"}
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                padding: "6px 18px",
                backgroundColor: "#f0f0f0",
                color: "#111",
                border: "1px solid #ccc",
                borderRadius: "999px",
                cursor: "pointer",
              }}
            >
              {currentLanguage === "Indonesia" ? "Tidak" : "No"}
            </button>
          </div>
        </div>
      ),
      {
        duration: 999999,
        id: "toggle-language-confirm",
        position: "top-center",
      }
    );
  };

  const handleAvatarClick = (avatar) => {
    setCurrentAvatar(avatar.name); // Update current avatar name
    const passphrase = avatar.key.passphrase;
    const config_id = avatar.id;
    const appId = avatar.app.id;
    const lang = avatar.language;

    sessionStorage.setItem("passphrase", passphrase);
    sessionStorage.setItem("config_id", config_id);
    sessionStorage.setItem("appId", appId);
    sessionStorage.setItem("language", lang);
    sessionStorage.setItem("topic", avatar.key.name);
    sessionStorage.setItem("avatar", avatar.name);

    navigate(`/avatar/${avatar.name}`, {
      state: {
        passphrase,
        config_id,
        appId,
        language: lang,
      },
    });

    setConfigId(config_id);
    window.location.reload();
  };

  return (
    <div className="Menu">
      <Toaster />
      {selectedMenu !== "EXPORT TRANSCRIPT" && (
        <div className="navbar">
          <div className="close-menu" style={{ visibility: "hidden" }}>
            <img src={closeMenuIcon} alt="Close Menu" />
          </div>
          <div className="menu__title">
            <p>{selectedMenu}</p>
          </div>
          <div className="close-menu" onClick={handleShowMenu}>
            <img src={closeMenuIcon} alt="Close Menu" />
          </div>
        </div>
      )}
      {selectedMenu === "MENU" ? (
        <div className="menu__content">
          <div
            className="menu__item"
            onClick={() => handleMenuClick("EXPORT TRANSCRIPT")}
          >
            <p>
              {
                translations[sessionStorage.getItem("language")]
                  .exportTranscript
              }
            </p>
          </div>
          <div
            className="menu__item"
            onClick={() =>
              handleMenuClick(
                translations[sessionStorage.getItem("language")].changeAvatar
              )
            }
          >
            <p>
              {translations[sessionStorage.getItem("language")].changeAvatar}
            </p>
          </div>
          <div className="menu__item menu__disabled">
            <p>
              {translations[sessionStorage.getItem("language")].switchTopic}
            </p>
          </div>
          <div className="menu__item menu__disabled">
            <p>
              {language === "English"
                ? "SWITCH TO BAHASA"
                : "Beralih ke Bahasa Inggris"}
            </p>
          </div>
          <div className="menu__item menu__disabled">
            <p>{translations[sessionStorage.getItem("language")].playGame}</p>
          </div>
        </div>
      ) : selectedMenu ===
        translations[sessionStorage.getItem("language")].changeAvatar ? (
        <div className="menu__content-submenu select-avatar__content">
          {avatars.length > 0 ? (
            avatars.map((avatar) => {
              const imgSrc = avatar?.avatar?.hyperlink
                ? `${BASE_URL}${avatar.avatar.hyperlink.replace(/\\/g, "/")}`
                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWN8hLKJungcUipWLReON9fse4yZcyB0rzNw&s";
              console.log("Image Source:", imgSrc);

              return (
                <div
                  key={avatar.id}
                  className="menu__avatar-item select-avatar__button"
                  onClick={() => handleAvatarClick(avatar)}
                >
                  <div className="avatar-container">
                    <img src={imgSrc} alt={avatar.name + " avatar"} />
                  </div>
                  <p>{avatar.name}</p>
                </div>
              );
            })
          ) : (
            <p>Loading avatars...</p>
          )}
        </div>
      ) : selectedMenu ===
        translations[sessionStorage.getItem("language")].switchTopic ? (
        <div className="menu__content select-topic__content">
          {topics.length > 0 ? (
            topics.map((topic) => (
              <div
                key={topic.id}
                className={`menu__item select-topic__button ${
                  activeTopic === topic.name ? "menu__active" : ""
                }`}
                onClick={() => handleTopicSelect(topic.passphrase, topic.name)}
              >
                <p>{topic.name}</p>
              </div>
            ))
          ) : (
            <p>Loading topics...</p>
          )}
        </div>
      ) : selectedMenu === "EXPORT TRANSCRIPT" ? (
        <ExportChat
          handleShowMenu={handleShowMenu}
          messages={messages}
          userName={userName}
        />
      ) : null}
    </div>
  );
};

export default Menu;
